// removed by extract-text-webpack-plugin
module.exports = {"container":"MobileSupportError__container___VENzZ","header":"MobileSupportError__header___EeqmM","subheader":"MobileSupportError__subheader___31vLO","mobileErrorIcon":"MobileSupportError__mobileErrorIcon___mLEdu","wevoIcon":"MobileSupportError__wevoIcon___ETEHp","footer":"MobileSupportError__footer___3BYAF","footerText":"MobileSupportError__footerText___2wFm4","footerLink":"MobileSupportError__footerLink___FaF9E","Select-animation-fadeIn":"MobileSupportError__Select-animation-fadeIn___E-h-s","Select-animation-spin":"MobileSupportError__Select-animation-spin___2bjkY"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/MobileSupportError.css
// module id = 1563
// module chunks = 0